module.exports = __webpack_public_path__ + "ceab8dcd7451db5dd5f7099ce536c8c5.png";